import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { KeepContact } from './usePaginateKeepContacts'

interface GetKeepContactByIdResponse {
  keepContact: KeepContact
}

const fetchKeepContactById = async (id: string): Promise<KeepContact> => {
  const { data } = await api.get<GetKeepContactByIdResponse>(`/keep-contacts/${id}`)
  return data.keepContact
}

export const useGetKeepContactById = (id: string) => {
  return useQuery<KeepContact>({
    queryKey: ['keep-contact', id],
    queryFn: () => fetchKeepContactById(id),
    enabled: !!id,
  })
}

